import { Validator as FormGuard } from 'form-guard';
import FGRequired                 from 'form-guard/dist/Rules/Required';
import FGEmail                    from 'form-guard/dist/Rules/Email';
import Rule                       from 'form-guard/dist/Rules/Rule';

class Required extends FGRequired {
    getMessage() {
        return "I didn't catch your " + this.getReadableFieldName();
    }
}

class Email extends FGEmail {
    getMessage() {
        return 'Hmm, looks fake'
    }
}

class Password extends Rule {
    validate() {
        if(this.value.length < 6) {
            return 'Do you even security?';
        }
    }
}

export default class Validator extends FormGuard {
    customRules() {
        return {
            required: Required,
            email   : Email,
            password: Password,
        }
    }
}
